import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useRewards } from '../context/RewardsContext';

// Points display button for navigation
export const PointsButton = ({ className = '' }) => {
  const navigate = useNavigate();
  const { points } = useRewards();

  return (
    <button
      onClick={() => navigate('/rewards')}
      className={`flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-yellow-400 to-orange-500 text-white font-bold rounded-full hover:scale-105 transition-transform shadow-lg ${className}`}
    >
      <span className="text-xl">⭐</span>
      <span>{points}</span>
    </button>
  );
};

// Floating reward animation when points are earned
export const RewardAnimation = () => {
  const { showRewardAnimation } = useRewards();

  if (!showRewardAnimation) return null;

  const { points, source } = showRewardAnimation;
  
  const sourceLabels = {
    correct: '✅ Correct Answer!',
    lesson: '📚 Lesson Complete!',
    daily: '🎯 Daily Challenge!',
    weekly: '🗓️ Weekly Goal!',
    achievement: '🏆 Achievement!',
  };

  return (
    <div className="fixed top-20 left-1/2 transform -translate-x-1/2 z-50 animate-bounce">
      <div className="bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-6 py-3 rounded-full shadow-2xl flex items-center gap-3">
        <span className="text-2xl">⭐</span>
        <div>
          <p className="font-bold text-lg">+{points} Points!</p>
          <p className="text-xs opacity-90">{sourceLabels[source] || 'Great job!'}</p>
        </div>
      </div>
    </div>
  );
};

// New achievement popup
export const AchievementPopup = () => {
  const { newAchievement } = useRewards();

  if (!newAchievement) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/50">
      <div className="bg-white rounded-3xl p-8 text-center max-w-sm mx-4 animate-bounce shadow-2xl">
        <div className="text-6xl mb-4">{newAchievement.emoji}</div>
        <h2 className="text-2xl font-bold text-gray-800 mb-2">Achievement Unlocked!</h2>
        <h3 className="text-xl font-bold text-purple-600 mb-2">{newAchievement.name}</h3>
        <p className="text-gray-600 mb-4">{newAchievement.description}</p>
        <div className="bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-4 py-2 rounded-full inline-block font-bold">
          +{newAchievement.reward} Points! ⭐
        </div>
      </div>
    </div>
  );
};

// Mini daily progress widget
export const DailyProgressMini = () => {
  const { getDailyChallenges } = useRewards();
  const challenges = getDailyChallenges();
  const completed = challenges.filter(c => c.completed).length;

  return (
    <div className="flex items-center gap-2 px-3 py-1.5 bg-white/80 rounded-full text-sm">
      <span>🎯</span>
      <span className="font-bold text-purple-600">{completed}/{challenges.length}</span>
    </div>
  );
};

export default PointsButton;
